/**
 * Single active discount for sales resolve / draft payloads.
 * Override wins; then typed input; then last resolved UI code; then saved order/cart code.
 */
export function getSalesResolveDiscountCode(args: {
  override?: string;
  userClearedCoupon?: boolean;
  couponInput?: string;
  liveDiscountCode?: string;
  savedDiscountCode?: string;
}): string {
  if (args.override !== undefined) {
    return String(args.override).trim();
  }
  if (args.userClearedCoupon) return "";
  const typed = String(args.couponInput ?? "").trim();
  if (typed) return typed;
  const live = String(args.liveDiscountCode ?? "").trim();
  if (live) return live;
  return String(args.savedDiscountCode ?? "").trim();
}
